export default __webpack_public_path__ + "static/media/PoweredByWhite.5ab30900.png";